import cn from 'classnames'
import React, { useState } from 'react'
import config from '../../config.json'
import FullImageView from '../fullimageview/FullImageView'

export const toVideoURL = (path) =>
    path.includes('http')
        ? path.replace('video:', '')
        : config.ipfs + path.replace('video:', '')

export const VideoElement = ({ video, poster }) => (
    <video
        loop
        className={'m-auto max-h-54 2xl:max-h-64'}
        autoPlay={true}
        muted={true}
        playsInline={true}
        poster={poster}
    >
        <source src={video} />
        Your browser does not support the video tag.
    </video>
)

export const ImageElement = (props) => (
    <img className={'m-auto max-w-64 max-h-48 2xl:max-h-64'} {...props} />
)

export const PopupImage = ({ image, video, alt, imgSize }) => {
    const [displayImage, setDisplayImage] = useState(null)
    const [displayVideo, setDisplayVideo] = useState(null)

    const toggleImage = () => {
        setDisplayImage(image)
        setDisplayVideo(video)
    }

    return (
        <>
            <FullImageView
                image={displayImage}
                video={displayVideo}
                toggleFunc={() => {
                    setDisplayImage(null)
                    setDisplayVideo(null)
                }}
            />
            <div
                className={cn('m-auto', {
                    'h-54 2xl:h-64': imgSize === 'medium',
                })}
                onClick={toggleImage}
            >
                {video ? (
                    <VideoElement video={toVideoURL(video)} />
                ) : (
                    <ImageElement src={image} alt={alt} />
                )}
            </div>
        </>
    )
}
